// TODO: this should become a Context once we move to a SPA
import { useSelector } from 'react-redux';

export const useShopConfig = () => useSelector(( state ) => state.config );
